import { render, staticRenderFns } from "./CourseRevenueStatistics.vue?vue&type=template&id=35c348ed&scoped=true"
import script from "./CourseRevenueStatistics.vue?vue&type=script&lang=ts"
export * from "./CourseRevenueStatistics.vue?vue&type=script&lang=ts"
import style0 from "./CourseRevenueStatistics.vue?vue&type=style&index=0&id=35c348ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c348ed",
  null
  
)

export default component.exports